<template>
  <listTemplate :classCustom="'list-job'">
    <template #header>
      <main-header>
        <template #filterByStatus>
          <filter-by-status
            @filterByStatus="filterByStatus"
            :filterStatus="taskStatusFilter"
            :pageTitle="pageTitle"
            :viewType="viewType"
          />
        </template>
      </main-header>
    </template>
    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <div class="leftContainer">
                <div class="leftSection">
                  <el-button
                    size="medium"
                    type="success"
                    class="createNew"
                    @click="isOpenCreateJobDialog = true"
                    v-if="
                      viewType === VIEW_TYPE.ASSIGNER ||
                        viewType === VIEW_TYPE.RECEIVER
                    "
                  >
                    <div class="flex-row flex__center font-weight-bold">
                      <i class="fas fa-ballot-check"></i>
                      <span
                      >&nbsp;&nbsp;
                        {{
                          viewType === VIEW_TYPE.RECEIVER
                            ? "Đăng ký"
                            : "Giao việc"
                        }}
                      </span>
                    </div>
                  </el-button>
                </div>
                <search
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #quickFilter>
                    <div class="leftSearch">
                      <div>
                    <div
                      class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__daterangepicker margin-top-5"
                    >
                      <span class="label-input width__auto"
                      >Thời gian bắt đầu</span
                      >
                      <el-date-picker
                        v-model="startDateRange"
                        type="daterange"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="right"
                        :clearable="false"
                        @change="startDateRangeChanged"
                      ></el-date-picker>
                    </div>
                      </div>
                      <div style="display: flex">
                    <div
                      class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large margin-top-5"
                      v-if="viewType === VIEW_TYPE.ASSIGNER"
                    >
                      <span class="label-input width__auto"
                      >Người thực hiện
                      </span>
                      <el-select
                        clearable
                        class="input-none__border has-border__bottom"
                        v-model="advanceSearchForm.receiverUserDeptRoleId"
                        filterable
                        placeholder="Người thực hiện"
                        size="medium"
                        @change="receiverUserDeptRoleIdChanged"
                      >
                        <el-option
                          v-for="item in receivers"
                          :key="item.id"
                          :value="item.id"
                          :label="`${item.fullName}`"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      class="margin-right-10 txt-center fix-width__small"
                      v-if="viewType === VIEW_TYPE.ASSIGNER"
                    >
                      <multiselect
                        :class="['style-fullWidth']"
                        :options="delegateFilterOptions"
                        label="name"
                        track-by="id"
                        v-model="delegateFilter"
                        :preselect-first="true"
                        placeholder="-"
                        :multiple="false"
                        :close-on-select="true"
                        :clear-on-select="true"
                        :searchable="true"
                        open-direction="bottom"
                        @input="filterByDelegateFilter"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">
                          <div
                            class="status-doc flex-row flex__left font-size__medium"
                          >
                            &nbsp;&nbsp;
                            <base-filter-icon
                              :iconClasses="[option.iconClass]"
                            />
                            <span>{{ option.name }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                      </div>
                    </div>
                  </template>
                  <template #advance>
                    <task-advance-search-dialog
                      :isOpen="isOpenAdvanceSearchDialog"
                      :taskType="taskType"
                      :form="advanceSearchForm"
                      :isDisableAssignerFilter="viewType === VIEW_TYPE.ASSIGNER"
                      :isDisableReceiverFilter="viewType === VIEW_TYPE.RECEIVER"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                    />
                  </template>
                </search>
                </div>
              </template>
            </subHeader>
          </template>
          <template #body>
            <main-content-cho-phe-duyet
              ref="mainContent"
              v-if="
                viewType === VIEW_TYPE.RECEIVER &&
                  taskStatusFilter === FILTER_STATUS.CHO_PHE_DUYET
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              @doSort="doSort"
              @viewDetail="viewDetail"
            />

            <main-content-hoan-thanh
              ref="mainContent"
              v-else-if="
                viewType === VIEW_TYPE.RECEIVER &&
                  taskStatusFilter === FILTER_STATUS.HOAN_THANH
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              @doSort="doSort"
              @viewDetail="viewDetail"
            />

            <main-content-ket-thuc
              ref="mainContent"
              v-else-if="
                viewType === VIEW_TYPE.RECEIVER &&
                  taskStatusFilter === FILTER_STATUS.KET_THUC
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              @doSort="doSort"
              @viewDetail="viewDetail"
            />

            <main-content-huy-tam-dung
              ref="mainContent"
              v-else-if="
                viewType === VIEW_TYPE.RECEIVER &&
                  taskStatusFilter === FILTER_STATUS.TAM_DUNG
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              @doSort="doSort"
              @viewDetail="viewDetail"
            />

            <mainContent
              ref="mainContent"
              v-else-if="
                viewType === VIEW_TYPE.RECEIVER &&
                  (!taskStatusFilter ||
                    taskStatusFilter === FILTER_STATUS.DANG_THUC_HIEN)
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              @doSort="doSort"
              @viewDetail="viewDetail"
            />

            <main-content-assigner-cho-phe-duyet
              ref="mainContent"
              v-else-if="
                viewType === VIEW_TYPE.ASSIGNER &&
                  taskStatusFilter === FILTER_STATUS.CHO_PHE_DUYET
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              :delegateFilter="advanceSearchForm.delegateFilterValue"
              @doSort="doSort"
              @viewDetail="viewDetail"
              @cloneTask="cloneTask"
            />

            <main-content-assigner-hoan-thanh
              ref="mainContent"
              v-else-if="
                viewType === VIEW_TYPE.ASSIGNER &&
                  taskStatusFilter === FILTER_STATUS.HOAN_THANH
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              :delegateFilter="delegateFilterValue"
              @doSort="doSort"
              @viewDetail="viewDetail"
              @cloneTask="cloneTask"
            />

            <main-content-assigner-ket-thuc
              ref="mainContent"
              v-else-if="
                viewType === VIEW_TYPE.ASSIGNER &&
                  taskStatusFilter === FILTER_STATUS.KET_THUC
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              :delegateFilter="delegateFilterValue"
              @doSort="doSort"
              @viewDetail="viewDetail"
              @cloneTask="cloneTask"
            />

            <main-content-assigner-huy-tam-dung
              ref="mainContent"
              v-else-if="
                viewType === VIEW_TYPE.ASSIGNER &&
                  taskStatusFilter === FILTER_STATUS.TAM_DUNG
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              :delegateFilter="delegateFilterValue"
              @doSort="doSort"
              @viewDetail="viewDetail"
              @cloneTask="cloneTask"
            />

            <main-content-assigner
              ref="mainContent"
              v-else-if="
                viewType === VIEW_TYPE.ASSIGNER &&
                  (!taskStatusFilter ||
                    taskStatusFilter === FILTER_STATUS.DANG_THUC_HIEN)
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              :delegateFilter="delegateFilterValue"
              @doSort="doSort"
              @viewDetail="viewDetail"
              @cloneTask="cloneTask"
            />

            <main-content-coordinator-cho-phe-duyet
              ref="mainContent"
              v-else-if="
                (viewType === VIEW_TYPE.COORDINATOR ||
                  viewType === VIEW_TYPE.DEPT_ASSIGNER) &&
                  taskStatusFilter === FILTER_STATUS.CHO_PHE_DUYET
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              :viewType="viewType"
              @doSort="doSort"
              @viewDetail="viewDetail"
              @cloneTask="cloneTask"
            />

            <main-content-coordinator-hoan-thanh
              ref="mainContent"
              v-else-if="
                (viewType === VIEW_TYPE.COORDINATOR ||
                  viewType === VIEW_TYPE.DEPT_ASSIGNER) &&
                  taskStatusFilter === FILTER_STATUS.HOAN_THANH
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              :viewType="viewType"
              @doSort="doSort"
              @viewDetail="viewDetail"
              @cloneTask="cloneTask"
            />

            <main-content-coordinator-ket-thuc
              ref="mainContent"
              v-else-if="
                (viewType === VIEW_TYPE.COORDINATOR ||
                  viewType === VIEW_TYPE.DEPT_ASSIGNER) &&
                  taskStatusFilter === FILTER_STATUS.KET_THUC
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              :viewType="viewType"
              @doSort="doSort"
              @viewDetail="viewDetail"
              @cloneTask="cloneTask"
            />

            <main-content-coordinator-huy-tam-dung
              ref="mainContent"
              v-else-if="
                (viewType === VIEW_TYPE.COORDINATOR ||
                  viewType === VIEW_TYPE.DEPT_ASSIGNER) &&
                  taskStatusFilter === FILTER_STATUS.TAM_DUNG
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              :viewType="viewType"
              @doSort="doSort"
              @viewDetail="viewDetail"
            />

            <main-content-coordinator
              ref="mainContent"
              v-else-if="
                (viewType === VIEW_TYPE.COORDINATOR ||
                  viewType === VIEW_TYPE.DEPT_ASSIGNER) &&
                  (!taskStatusFilter ||
                    taskStatusFilter === FILTER_STATUS.DANG_THUC_HIEN)
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              :viewType="viewType"
              @doSort="doSort"
              @viewDetail="viewDetail"
              @cloneTask="cloneTask"
            />

            <main-content-all
              ref="mainContent"
              v-else-if="
                (viewType === VIEW_TYPE.ALL)
              "
              :advanceSearchForm="advanceSearchForm"
              :taskStatuses="taskStatuses"
              :sort="sort"
              :order="order"
              :usingAdvanceSearch="usingAdvanceSearch"
              :keyword="keyword"
              :viewType="viewType"
              @doSort="doSort"
              @viewDetail="viewDetail"
              @cloneTask="cloneTask"
            />

            <task-create-dialog
              :isOpen="isOpenCreateJobDialog"
              :taskType="taskType"
              :viewType="viewType"
              :copyFromTaskId="copyFromTaskId"
              v-if="isEnableCreateJobDialog"
              @dialogClosed="isEnableCreateJobDialog = false"
              @closeDialog="isOpenCreateJobDialog = false"
              @success="createChildTaskSuccess"
            />
          </template>
        </listTemplate>
      </div>
    </template>
  </listTemplate>
</template>

<script>
  import utils from "../../services/utils";
  import h from "../../services/h";
  import constants from "../../constants";
  import goBackMixin from "../../mixins/goBackMixin";
  import errorMessageFilter from "../../filters/errorMessageFilter";
  import MainContentCoordinatorChoPheDuyet from "./components/main-content-coordinator-choPheDuyet";
  import MainContentCoordinatorHoanThanh from "./components/main-content-coordinator-hoanThanh";
  import MainContentCoordinatorKetThuc from "./components/main-content-coordinator-ketThuc";
  import MainContentCoordinatorHuyTamDung from "./components/main-content-coordinator-huyTamDung";
  import MainContentCoordinator from "./components/main-content-coordinator";
  import TaskCreateDialog from "./create-job/task-create-dialog";
  import BaseFilterIcon from "../common/base-filter-icon";
  import userDeptRoleViewService from "../../services/userDeptRoleViewService";
  import TaskAdvanceSearchDialog from "./components/advanceSearch";
  import dateUtils from "../../dateUtils";

  export default {
    name: "job-index",
    mixins: [goBackMixin],
    components: {
      TaskCreateDialog,
      TaskAdvanceSearchDialog,
      BaseFilterIcon,
      MainContentCoordinator,
      MainContentCoordinatorHuyTamDung,
      MainContentCoordinatorKetThuc,
      MainContentCoordinatorHoanThanh,
      MainContentCoordinatorChoPheDuyet,
      listTemplate: () => import("../common/list.vue"),
      mainHeader: () => import("../../components/header/main-header.vue"),
      filterByStatus: () => import("./components/filter-by-status-header.vue"),
      listJob: () => import("./list-job.vue"),
      subHeader: () => import("../../components/main/sub-header.vue"),
      search: () => import("../common/search.vue"),

      mainContent: () => import("./components/main-content.vue"),
      // mainContentAssignedByOther: () =>
      //   import("./components/main-content-assigned-by-other.vue"),
      mainContentHoanThanh: () =>
        import("./components/main-content-hoanThanh.vue"),
      mainContentKetThuc: () => import("./components/main-content-ketThuc.vue"),
      mainContentHuyTamDung: () =>
        import("./components/main-content-huyTamDung.vue"),
      mainContentChoPheDuyet: () =>
        import("./components/main-content-choPhetDuyet.vue"),
      mainContentAssigner: () => import("./components/main-content-assigner"),
      mainContentAssignerChoPheDuyet: () =>
        import("./components/main-content-assigner-choPheDuyet"),
      mainContentAssignerHoanThanh: () =>
        import("./components/main-content-assigner-hoanThanh"),
      mainContentAssignerKetThuc: () =>
        import("./components/main-content-assigner-ketThuc"),
      mainContentAssignerHuyTamDung: () =>
        import("./components/main-content-assigner-huyTamDung"),
      mainContentAll: () => import("./components/main-content-all"),
      reviewJob: () => import("./components/review-job-dialog.vue"),
      updateProgressJob: () => import("./components/updateProgressJob.vue"),
      gHanJob: () => import("./components/GHanJob.vue"),
      refuseJob: () => import("./components/refuseJob.vue")
    },

    data() {
      return {
        advanceSearchForm: {
          fromStartDate: null,
          toStartDate: null,
        progressStatus: null,
          taskTitle: null,
          taskDetail: null,
          fromDeadline: null,
          toDeadline: null,
          assignerUserDeptRoleId: null,
          receiverUserDeptRoleId: null,
          keyword: null,
          delegateFilter: null,
          taskStatuses: null,
          taskStatusFilter: null,
          isTaskAssignedByOther: null
        },
        keyword: null,
        taskStatusFilter: null,
        sort: null,
        order: null,
        usingAdvanceSearch: null,
        taskStatuses: null,
        taskAssignedByOther: null,
        delegateFilterOptions: [],
        delegateFilter: null,

        isOpenCreateJobDialog: false,
        isEnableCreateJobDialog: false,
        isOpenAdvanceSearchDialog: false,
        isEnableAdvanceSearchDialog: false,
        copyFromTaskId: null,

        VIEW_TYPE: constants.JOB_INDEX_PAGE.VIEW_TYPE,
        FILTER_STATUS: constants.JOB_INDEX_PAGE.FILTER_STATUS,
        DELEGATE_FILTER: constants.TK_TASK_VIEW.DELEGATE_FILTER,

        receivers: [],
        startDateRange: null,
        dateQuickFilterOption: null
      };
    },

    computed: {
      delegateFilterValue() {
        return this.advanceSearchForm.delegateFilter;
      },

      viewType() {
        return this.$route.query.viewType;
      },

      taskType() {
        switch (this.viewType) {
          case constants.JOB_INDEX_PAGE.VIEW_TYPE.RECEIVER:
            return constants.TASK_TASK_TYPE.DANGKI;
          case constants.JOB_INDEX_PAGE.VIEW_TYPE.ASSIGNER:
            return constants.TASK_TASK_TYPE.GIAOVIEC;
          case constants.JOB_INDEX_PAGE.VIEW_TYPE.DEPT_ASSIGNER:
            return constants.TASK_TASK_TYPE.DEPT_ASSIGNER;
          default:
            return null;
        }
      },

      pageTitle() {
        switch (this.viewType) {
          case constants.JOB_INDEX_PAGE.VIEW_TYPE.RECEIVER:
            return errorMessageFilter({
              errorCode: "jobIndexPage.pageTitle.receiver"
            });
          case constants.JOB_INDEX_PAGE.VIEW_TYPE.ASSIGNER:
            return errorMessageFilter({
              errorCode: "jobIndexPage.pageTitle.assigner"
            });
          case constants.JOB_INDEX_PAGE.VIEW_TYPE.DEPT_ASSIGNER:
            return errorMessageFilter({
              errorCode: "jobIndexPage.pageTitle.deptAssigner"
            });
          case constants.JOB_INDEX_PAGE.VIEW_TYPE.COORDINATOR:
            return errorMessageFilter({
              errorCode: "jobIndexPage.pageTitle.coordinator"
            });
          case constants.JOB_INDEX_PAGE.VIEW_TYPE.ALL:
            return errorMessageFilter({
              errorCode: "jobIndexPage.pageTitle.all"
            });
          default:
            return "";
        }
      }
    },

    watch: {
      viewType() {
        this.initQuery();
        this.doSearch();
      },

      isOpenCreateJobDialog(newValue) {
        newValue
          ? (this.isEnableCreateJobDialog = newValue)
          : (this.copyFromTaskId = null);
      },

      isOpenAdvanceSearchDialog(newValue) {
        newValue && (this.isEnableAdvanceSearchDialog = newValue);
      }
    },

    created() {
      this.initDelegateFilterOptions();
      this.initQuery();
      this.registerEventBusForMaster(() => this.doSearch());
      this.loadReceivers();
      this.initDateQuickFilterOption();
      this.initDelegateFilter();
      this.registerEventBusForMaster(event => {
        this.doSearch();
      });
      this.doSearch()
    },

    destroyed() {
      this.unregisterEventBusForMaster();
    },

    methods: {
      initStartDateRange() {
        this.startDateRange = utils.initTimeRange(
          this.advanceSearchForm.fromStartDate,
          this.advanceSearchForm.toStartDate
        );

        if (!this.startDateRange) {
          utils.timeRangeChanged(
            (this.startDateRange = dateUtils.getDatesByQuickFilter(
              constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
            )),
            (from_, to_) => {
              this.advanceSearchForm.fromStartDate = from_;
              this.advanceSearchForm.toStartDate = to_;
            }
          );
        }
      },

      initDateQuickFilterOption() {
        this.dateQuickFilterOption = {
          shortcuts: [
            utils.buildDateQuickFilterOption(
              constants.DATE_QUICK_FILTER.CODE.THIS_MONTH_2
            ),
            utils.buildDateQuickFilterOption(
              constants.DATE_QUICK_FILTER.CODE.LAST_MONTH
            ),
            utils.buildDateQuickFilterOption(
              constants.DATE_QUICK_FILTER.CODE.NAM_NAY
            )
          ]
        };
      },

      filterByIncomingDateRange() {
        utils.timeRangeChanged(this.startDateRange, (from_, to_) => {
          this.advanceSearchForm.fromStartDate = from_;
          this.advanceSearchForm.toStartDate = to_;
        });
        this.doSearch();
      },

      loadReceivers() {
        userDeptRoleViewService.findAllReceiversForTaskV2().then(response => {
          this.receivers = (response.data || []).sort((node1, node2) =>
            utils.compareUserDeptRoleView(node1, node2)
          );
        });
      },

      initDelegateFilterOptions() {
        this.delegateFilterOptions = [
          {
            id: constants.TK_TASK_VIEW.DELEGATE_FILTER.ALL,
            name: "Tất cả",
            iconClass: "font-size__medium fa fa-check color__silver icon-status"
          },
          {
            id: constants.TK_TASK_VIEW.DELEGATE_FILTER.DIRECT,
            name: "Công việc tôi giao",
            iconClass: "font-size__medium fa fa-user color__cyan icon-status"
          },
          {
            id: constants.TK_TASK_VIEW.DELEGATE_FILTER.DELEGATE,
            name: "Công việc ủy quyền",
            iconClass: "font-size__medium fa fa-users color__green icon-status"
          }
        ];
      },

      createChildTaskSuccess() {
        this.isOpenCreateJobDialog = false;
        this.doSearch();
      },

      viewDetail(event) {
        let tkTask = event.tkTask;
        let params = utils.merge(this.$route.params, {id: tkTask.id});
        let currentNameRoute = this.$route.name;
        let detailRouteName;
        switch (currentNameRoute) {
          case "job-index":
            detailRouteName = "detail-job";
            break;
          case "job-index-assigned":
            detailRouteName = "detail-job-assigned";
            break;
          case "job-index-dept-assigned":
            detailRouteName = "detail-job-dept-assigned";
            break;
          case "job-index-coordinate":
            detailRouteName = "detail-job-coordinate";
            break;
          case "job-index-all":
            detailRouteName = "detail-job-all";
            break;
        }
        this.$router.push({
          name: detailRouteName,
          params: params,
          query: this.buildQuery()
        });
      },

      initQuery() {
        let query = this.$route.query;
        let receiverUserDeptRoleId = utils.getParamFromQuery(
          query,
          "receiverUserDeptRoleId"
        );

        this.advanceSearchForm.fromStartDate = utils.getIntParamsFromQuery(
          query,
          "fromStartDate"
        );

        this.advanceSearchForm.toStartDate = utils.getIntParamsFromQuery(
          query,
          "toStartDate"
        );

      this.advanceSearchForm.progressStatus = utils.getParamFromQuery(
        query,
        "progressStatus"
      );
        this.advanceSearchForm.receiverUserDeptRoleId = receiverUserDeptRoleId;

        this.advanceSearchForm.fromStartDate = utils.getIntParamsFromQuery(
          query,
          "fromStartDate"
        );
        this.advanceSearchForm.toStartDate = utils.getIntParamsFromQuery(
          query,
          "toStartDate"
        );
        this.advanceSearchForm.taskTitle = utils.getParamFromQuery(
          query,
          "taskTitle"
        );
        this.advanceSearchForm.taskDetail = utils.getParamFromQuery(
          query,
          "taskDetail"
        );
        this.advanceSearchForm.fromDeadline = utils.getIntParamsFromQuery(
          query,
          "fromDeadline"
        );
        this.advanceSearchForm.toDeadline = utils.getIntParamsFromQuery(
          query,
          "toDeadline"
        );
        this.advanceSearchForm.assignerUserDeptRoleId = utils.getParamFromQuery(
          query,
          "assignerUserDeptRoleId"
        );
        this.advanceSearchForm.receiverUserDeptRoleId = utils.getParamFromQuery(
          query,
          "receiverUserDeptRoleId"
        );
        this.advanceSearchForm.keyword = utils.getParamFromQuery(
          query,
          "keyword"
        );
        this.advanceSearchForm.delegateFilter = utils.getParamFromQuery(
          query,
          "delegateFilter"
        );
        this.advanceSearchForm.taskStatusFilter = this.taskStatusFilter = utils.getParamFromQuery(
          query,
          "taskStatusFilter"
        );
        this.advanceSearchForm.isTaskAssignedByOther = utils.getParamFromQuery(
          query,
          "isTaskAssignedByOther"
        );
        this.sort = utils.getIntParamsFromQuery(query, "sort") || "updateTime";
        this.sort = utils.getIntParamsFromQuery(query, "order") || "desc";
        this.initStartDateRange();
        this.initDelegateFilter();
        this.initTaskStatuses();
      },

      initTaskStatuses() {
        switch (this.taskStatusFilter) {
          case constants.JOB_INDEX_PAGE.FILTER_STATUS.DANG_THUC_HIEN:
            this.advanceSearchForm.taskStatuses = this.taskStatuses = [
              constants.TASK_STATUS.DANG_THUC_HIEN
            ];
            return;
          case constants.JOB_INDEX_PAGE.FILTER_STATUS.HOAN_THANH:
            this.advanceSearchForm.taskStatuses = this.taskStatuses = [
              constants.TASK_STATUS.HOAN_THANH
            ];
            return;
          case constants.JOB_INDEX_PAGE.FILTER_STATUS.TAM_DUNG:
            this.advanceSearchForm.taskStatuses = this.taskStatuses = [
              constants.TASK_STATUS.TAM_DUNG,
              constants.TASK_STATUS.HUY,
              constants.TASK_STATUS.HUY_PHE_DUYET_DK
            ];
            return;
          case constants.JOB_INDEX_PAGE.FILTER_STATUS.CHO_PHE_DUYET:
            this.advanceSearchForm.taskStatuses = this.taskStatuses = [
              constants.TASK_STATUS.CHO_PHE_DUYET_DK
            ];
            return;
          case constants.JOB_INDEX_PAGE.FILTER_STATUS.KET_THUC:
            this.advanceSearchForm.taskStatuses = this.taskStatuses = [
              constants.TASK_STATUS.KET_THUC
            ];
            return;
          default:
            this.advanceSearchForm.taskStatuses = this.taskStatuses = null;
        }
      },

      initDelegateFilter(value) {
        this.delegateFilter = h.find(
          this.delegateFilterOptions,
          option => option.id === value
        );
      },

      buildQuery() {
        return utils.merge(this.advanceSearchForm, {viewType: this.viewType});
      },

      resetForm() {
        this.advanceSearchForm.taskStatusFilter = null;
        this.advanceSearchForm.isTaskAssignedByOther = null;
        this.advanceSearchForm.fromStartDate = null;
        this.advanceSearchForm.toStartDate = null;
        this.advanceSearchForm.taskTitle = null;
        this.advanceSearchForm.taskDetail = null;
        this.advanceSearchForm.fromDeadline = null;
        this.advanceSearchForm.toDeadline = null;
        this.advanceSearchForm.assignerUserDeptRoleId = null;
        this.advanceSearchForm.receiverUserDeptRoleId = null;
        this.advanceSearchForm.keyword = null;
      },

      filterByStatus(event) {
        // this.resetForm();
        this.advanceSearchForm.taskStatusFilter = this.taskStatusFilter =
          event.filterStatus;
        this.advanceSearchForm.isTaskAssignedByOther = this.taskAssignedByOther =
          event.taskAssignedByOther;
        this.initStartDateRange();
        this.initTaskStatuses();
        this.doSearchStatus();
      },

      simpleSearch(keyword) {
        this.advanceSearchForm.keyword = this.keyword = keyword;
        this.advanceSearchForm.taskTitle = null;
        this.advanceSearchForm.taskDetail = null;
        this.advanceSearchForm.fromDeadline = null;
        this.advanceSearchForm.toDeadline = null;
        this.advanceSearchForm.receiverUserDeptRoleId = null;
        this.doSearch();
      },

      advanceSearch(event) {
        let advanceSearchForm = event.advanceSearchForm;
        this.advanceSearchForm.keyword = this.keyword = null;
        this.advanceSearchForm.taskTitle = advanceSearchForm.taskTitle;
        this.advanceSearchForm.taskDetail = advanceSearchForm.taskDetail;
        this.advanceSearchForm.fromDeadline = advanceSearchForm.fromDeadline;
        this.advanceSearchForm.toDeadline = advanceSearchForm.toDeadline;
        this.advanceSearchForm.receiverUserDeptRoleId =
          advanceSearchForm.receiverUserDeptRoleId;
        this.advanceSearchForm.assignerUserDeptRoleId = advanceSearchForm.assignerUserDeptRoleId;
      this.advanceSearchForm.progressStatus =
        advanceSearchForm.progressStatus;
        this.doSearch();
      },

      filterByDelegateFilter() {
        this.advanceSearchForm.delegateFilter = this.delegateFilter.id;
        this.doSearch();
      },

      startDateRangeChanged() {
        utils.timeRangeChanged(this.startDateRange, (from_, to_) => {
          this.advanceSearchForm.fromStartDate = from_;
          this.advanceSearchForm.toStartDate = to_;
        });
        this.doSearch();
      },

      receiverUserDeptRoleIdChanged() {
        this.doSearch();
      },

      doSort(event) {
        this.sort = event.sort;
        this.order = event.order;
        this.doSearch();
      },

      getRouteName() {
        switch (this.$route.name) {
          case "detail-job":
            return "job-index";
          case "detail-job-assigned":
            return "job-index-assigned";
          case "detail-job-dept-assigned":
            return "job-index-dept-assigned";
          case "detail-job-coordinate":
            return "job-index-coordinate";
          case "detail-job-all":
            return "job-index-all";
          default:
            return this.$route.name;
        }
      },

      getRouteNameStatus() {
        switch (this.$route.name) {
          // case "detail-job":
          //   return "job-index";
          // case "detail-job-assigned":
          //   return "job-index-assigned";
          // case "detail-job-dept-assigned":
          //   return "job-index-dept-assigned";
          case "sub-detail-job":
            return "job-index-assigned";
          // case "detail-job-coordinate":
          //   return "job-index-coordinate";
          default:
            return this.getRouteName();
        }
      },

      doSearch() {
        this.$router.replace({
          name: this.getRouteName(),
          params: this.$route.params,
          query: this.buildQuery()
        });
        this.$nextTick(
          () => this.$refs.mainContent && this.$refs.mainContent.doSearch()
        );
      },

      doSearchStatus() {
        this.$router.replace({
          name: this.getRouteNameStatus(),
          params: this.$route.params,
          query: this.buildQuery()
        });
        this.$nextTick(
          () => this.$refs.mainContent && this.$refs.mainContent.doSearch()
        );
      },

      cloneTask(event) {
        this.copyFromTaskId = event.tkTaskId;
        this.isOpenCreateJobDialog = true;
      }
    }
  };
</script>

<style scoped>
  .fix-width__daterangepicker {
    flex: auto 0 0;
    width: 330px;
  }
  .leftContainer {
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .leftSearch {
    display: flex;
  }

  @media only screen and (min-width: 12in) and (max-width: 16in) {
    .leftContainer {
      display: flex;
    }
    .createNew {
      margin-top: 10px;
    }
    .leftSearch {
      display: flex;
      flex-direction: column;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/job/task-index.vue